import { render, staticRenderFns } from "./MediaOwnersSingle.vue?vue&type=template&id=d057ff1c&"
import script from "./MediaOwnersSingle.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports